import { request } from "@umijs/max";


export async function login(body: User.LoginParams, options?: { [key: string]: any }) {
  return request<Common.ReponseResult<User.LoginResult>>('/filmpartnerapi/user/login', { data: body, options });
}

export async function currentUser(options?: { [key: string]: any }) {
  return request<Common.ReponseResult<User.LoginResult>>('/filmpartnerapi/user/currentUser', { options });
}

export async function updatePwd(body: User.ChangePasswordParams, options?: { [key: string]: any }) {
  return request<Common.ReponseResult<string>>('/filmpartnerapi/user/updatePwd', { data: body, options });
}

// 前5 后3
export async function getTaskList(options?: { [key: string]: any }) {
  return request<Common.ReponseResult<Common.Task[]>>('/filmpartnerapi/user/getTaskList', { options });
}
